// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3165":"7f20f4335cf35a52","3207":"d52d8617afd071ce","6317":"85c26489ef29a945","6348":"1c229545dc296900"}[chunkId] + ".js";
};